import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function listCountry(params) {

    let requestUrl = `${url}/geo_ip/list_country?`;
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            requestUrl += `${key}=${params[key]}&`;
        }
    }
    return axios.get(requestUrl)
        .then(response => {
            return {
                listCountry: response.data,
                meta: response.data.meta
            };
        });
}

function defaultBonusSettings() {
    return axios.get(`${url}/geo_ip/default_value`)
        .then(response => {
            return response.data;
        });
}

async function updateDefaultSetting(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/geo_ip/update_default_value`, payload, options)
        .then(response => {
            return response.data;
        });
}

function addNewCountryCredits(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/geo_ip/add_country_credits`,payload,options)
        .then(response => {
            return response.data;
        });
}

function listCountryCredits() {
    return axios.get(`${url}/geo_ip/list_country_credits`)
        .then(response => {
            return {
                listCountryCredits: response.data,
                meta: response.data.meta
            };
        });
}

function deleteCountryCredits(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/geo_ip/delete_country_credits`,payload,options)
        .then(response => {
            return response.data;
        });
}

function getTestOrderInfo(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/test_order_locale_info`,payload,options)
        .then(response => {
            return {testorderinfo: response.data};
        });
}

function updateTestOrderInfo(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/test_order_locale`,payload,options)
        .then(response => {
            return {testorderupdate: response.data};
        });
}

function massStartBonusUpdate(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/geo_ip/mass-start-bonus-update`,payload,options)
        .then(response => {
            return {massStartBonusUpdate: response.data};
        });
}

export default {
    listCountry,
    defaultBonusSettings,
    updateDefaultSetting,
    addNewCountryCredits,
    listCountryCredits,
    deleteCountryCredits,
    getTestOrderInfo,
    updateTestOrderInfo,
    massStartBonusUpdate
};